// Drillhole Validation Service - connects to Postgres via Azure Function
import { authService } from '../auth/authService';

class DrillholeValidationService {
  constructor() {
    // Use dedicated wolfwalker-api Function App (Python Flex Consumption with VNet)
    this.functionAppUrl = 'https://wolfwalker-api-b7abdbh3apbdavga.canadacentral-01.azurewebsites.net';
    
    // Azure Function endpoints for drillhole validation (to be created)
    this.validationApiUrl = `${this.functionAppUrl}/api/drillhole_validation`;
  }

  async getAuthenticatedHeaders() {
    try {
      const token = await authService.getAccessToken();
      const userInfo = authService.getUserInfo();
      
      return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'x-user-id': userInfo?.email || userInfo?.username || 'unknown'
      };
    } catch (error) {
      console.error('Failed to get auth headers:', error);
      throw new Error('Authentication failed');
    }
  }

  /**
   * Get drillhole validation data
   * Returns validation results and data quality checks for drillholes
   */
  async getValidationData(options = {}) {
    try {
      const { limit, offset = 0 } = options;

      const headers = await this.getAuthenticatedHeaders();
      const params = new URLSearchParams();
      if (limit != null && limit !== '') {
        params.append('limit', String(limit));
      }
      if (offset) {
        params.append('offset', String(offset));
      }
      if (options.source_project_name) {
        params.append('source_project_name', options.source_project_name);
      }
      const query = params.toString();
      const url = query
        ? `${this.validationApiUrl}?${query}`
        : this.validationApiUrl;

      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch drillhole validation data: ${response.statusText}`);
      }

      const result = await response.json();
      return {
        success: result.success,
        data: result.data || [],
        message: result.message
      };
    } catch (error) {
      console.error('Error fetching drillhole validation data:', error);
      throw error;
    }
  }

  /**
   * Get all dashboard data for display
   */
  async getDashboardData() {
    try {
      const validationData = await this.getValidationData();

      return {
        validationData: validationData.data,
        success: true
      };
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }

  /**
   * Filter data by search term
   */
  filterData(data, searchTerm) {
    if (!searchTerm) return data;
    const term = searchTerm.toLowerCase();
    return data.filter(item => 
      JSON.stringify(item).toLowerCase().includes(term)
    );
  }

  /**
   * Sort data by field and direction
   */
  sortData(data, field, direction = 'asc') {
    return [...data].sort((a, b) => {
      const aVal = a[field] ?? '';
      const bVal = b[field] ?? '';
      
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return direction === 'asc' ? aVal - bVal : bVal - aVal;
      }
      
      if (direction === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });
  }
}

// Export singleton instance
export const drillholeValidationService = new DrillholeValidationService();
export default drillholeValidationService;
